import Vue from 'vue'
import Router from 'vue-router'

import Index from '@/components/Index'
import Login from '@/components/Login/Index'
import Register from '@/components/Register/Index'
import AccountEdit from '@/components/AccountEdit/Index'
import PasswordEdit from '@/components/PasswordEdit/Index'
import ClientLogin from '@/components/Login/Client'
import ClientIndex from '@/components/ClientIndex'
import Notice from '@/components/Notice/Index'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index,
      meta: {
				title: '食堂预约'
			}
    },
    {
      path: '/Login',
      component: Login,
      meta: {
				title: '食堂预约'
			}
    },
    {
      path: '/Register',
      component: Register,
      meta: {
				title: '食堂预约'
			}
    },
    {
      path: '/AccountEdit',
      component: AccountEdit,
      meta: {
				title: '食堂预约'
			}
    }
    ,
    {
      path: '/PasswordEdit',
      component: PasswordEdit,
      meta: {
				title: '食堂预约'
			}
    },
    {
      path:'/ClientLogin',
      component:ClientLogin,
      meta: {
				title: '食堂预约'
			}
    },
    {
      path:'/ClientIndex',
      component:ClientIndex,
      meta: {
				title: '食堂预约'
			}
    },
    {
      path:'/Notice',
      component:Notice,
      meta: {
				title: '通知'
			}
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js